import React from 'react'

import { useAuth } from 'src/modules/auth'
import { SecondaryNavLayout } from 'src/modules/ui'

import EnvironmentSelector from './EnvironmentSelector'
import CreateOrderView from './CreateOrderView'
import DraftOrderView from './DraftOrderView'
import DraftOrderListView from './DraftOrderListView'
import EditDraftOrderView from './EditDraftOrderView'
import SubmittedOrderListView from './SubmittedOrderListView'
import SubmittedOrderView from './SubmittedOrderView'
import ScheduledOrderListView from './scheduledOrders/ScheduledOrderListView'

const Purchasing = () => {
  const { user } = useAuth()

  const routes = [
    {
      navLabel: 'Create Order',
      path: '/purchasing/create-order',
      component: CreateOrderView,
    },
    {
      navLabel: 'Drafts',
      path: '/purchasing/drafts',
      exact: true,
      component: DraftOrderListView,
    },
    {
      navLabel: 'Submitted',
      path: '/purchasing/submitted',
      exact: true,
      component: SubmittedOrderListView,
    },
    {
      navLabel: 'Repeating Orders',
      path: '/purchasing/scheduled',
      exact: true,
      component: ScheduledOrderListView,
    },
    {
      path: '/purchasing/drafts/:id',
      component: DraftOrderView,
      exact: true,
      title: 'Drafts',
    },
    {
      path: '/purchasing/drafts/:id/edit',
      component: EditDraftOrderView,
      exact: true,
      title: 'Drafts',
    },
    {
      path: '/purchasing/submitted/:id',
      component: SubmittedOrderView,
      exact: true,
      title: 'Submitted',
    },
  ]

  let extraControl
  if (user.organisation.environmentCount > 1) {
    extraControl = <EnvironmentSelector />
  }

  return <SecondaryNavLayout extraControl={extraControl} routes={routes} />
}

export default Purchasing
